module.exports = __webpack_public_path__ + "img/zhytomyr.91d4f7c1.png";